import { InternalServerError } from '@module/mdrt-org/shared/utils/http-services/error-definitions';
import { throwResponseErrors } from '@module/mdrt-org/shared/utils/http-services/throw-response-errors';

export const mutateWithErrorHandling = async <T>(
  apiUrl: Request | string | URL,
  { cache, ...rest }: RequestInit
): Promise<T | undefined> => {
  const response = await fetch(apiUrl, {
    ...rest,
    cache: cache ?? 'no-store',
  });

  const contentType = response.headers.get('content-type');

  if (response.ok) {
    if (response.headers.get('Content-Length') === '0') {
      return undefined;
    }

    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    }
  }

  await throwResponseErrors(response);
  // This line is unreachable, but required for type safety
  throw new InternalServerError();
};
